<a class="btn btn-outline-secondary" [routerLink]="['/mbq']">
  <i class="bi bi-arrow-left"></i> Back to MBQ
</a>
<div class="stocktake-container container my-4 bg-white me-4">
  <h2 class="mb-4">{{ title }}</h2>



  <app-excel-upload *ngIf="!draftId" [uploadUrl]="uploadUrl" (uploadSuccess)="onUploadSuccess($event)"
    (uploadError)="onUploadError($event)"></app-excel-upload>



  <div *ngIf="draftId" class="mt-5">
    <div *ngIf="!isViewMode" class="row g-3 mb-4 align-items-end">
      <div class="col-md-3 form-group position-relative">
        <label class="form-label">Search & Add by SKU</label>
        <ng-select [items]="productSearchResults" bindLabel="sku" [typeahead]="skuSearchSubject"
          [(ngModel)]="selectedBaseProduct" [loading]="isSearchingSku" placeholder="Enter SKU..."
          (change)="onProductSelected($event)" (blur)="clearSearch('sku')" [clearable]="true">
          <ng-template ng-label-tmp let-item="item">
            {{ item.sku }} - {{ item.name }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div class="d-flex flex-column">
              <div class="fw-bold">{{ item.sku }}</div>
              <small class="text-muted">{{ item.name }}</small>
            </div>
          </ng-template>
        </ng-select>
      </div>

      <div class="col-md-3 form-group position-relative">
        <label class="form-label">Search & Add by Product Name</label>
        <ng-select [items]="productSearchResults" bindLabel="name" [typeahead]="nameSearchSubject"
          [(ngModel)]="selectedBaseProduct" [loading]="isSearchingName" placeholder="Enter product name..."
          (change)="onProductSelected($event)" (blur)="clearSearch('name')" [clearable]="true">
          <ng-template ng-label-tmp let-item="item">
            {{ item.name }} - {{ item.sku }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div class="d-flex flex-column">
              <div class="fw-bold">{{ item.name }}</div>
              <small class="text-muted">{{ item.sku }}</small>
            </div>
          </ng-template>
        </ng-select>
      </div>

      <div class="col-md-2 form-group">
        <label class="form-label">MBQ</label>
        <input type="number" class="form-control" [(ngModel)]="newMbq" min="1" required />
      </div>

      <div class="col-md-2 form-group">
        <label class="form-label">Reorder Level</label>
        <input type="number" class="form-control" [(ngModel)]="newReorderLevel " min="1" required />
      </div>
      <div class="col-md-3 form-group">
        <label class="form-label">Store</label>
        <select class="form-select" [(ngModel)]="storeId" required>
          <option *ngFor="let store of stores" [value]="store.id">{{ store.storeCode }}--{{store.name }}</option>
        </select>
      </div>

      <div class="col-md-2 form-group">
        <button class="btn btnprimary" type="button" [disabled]="
            !quantityToAdd || quantityToAdd <= 0 || !selectedBaseProduct
          " (click)="addProductToDraft()">
          <i class="bi bi-plus-lg me-1"></i> Add Item
        </button>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-bordered table-hover align-middle">
        <thead class="table-light">
          <tr>
            <th>#</th>
            <th> Store Code</th>
            <th>SKU</th>
            <th>Product Name</th>
            <th class="text-center" style="width: 15%">MBQ</th>
            <th class="text-center" style="width: 15%">Reorder Level</th>
            <th *ngIf="!isViewMode">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of itemsList; index as i">
            <td>{{ i + 1 }}</td>
            <td>{{item.storeCode}}</td>
            <td>{{ item.sku }}</td>
            <td>{{ item.displayName }}</td>

            <td class="text-center">
              <input type="number" class="form-control text-center form-control-sm" [(ngModel)]="item.newMbq"
                (ngModelChange)="onQtyChange(item)" [disabled]="isViewMode" min="0"
                style="max-width: 100px; margin: 0 auto" />
            </td>

            <td class="text-center">
              <input type="number" class="form-control text-center form-control-sm" [(ngModel)]="item.newReorderLevel"
                (ngModelChange)="onQtyChange(item)" [disabled]="isViewMode" min="0"
                style="max-width: 100px; margin: 0 auto" />
            </td>


            <td *ngIf="!isViewMode">
              <button class="btn btn-sm btn-danger me-2" [disabled]="isViewMode" (click)="deleteRow(item)">
                Delete
              </button>
              <button class="btn btn-sm btnprimary" [disabled]="isViewMode" (click)="updateItem(item)">
                Update
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <app-pagination [total]="total" [page]="page" [limit]="limit" [pageCount]="pageCount"
      [limitOptions]="[10, 20, 30, 50]" (paginate)="onPaginate($event)">
    </app-pagination>

  </div>

  <div *ngIf="draftId && !isViewMode">
    <button class="btn btn-secondary m-2" (click)="save()">Save</button>
    <button class="btn btnprimary" (click)="submitDraftItems()">Submit</button>

  </div>
</div>

<app-confirm-dialog #confirmDelete [title]="'Delete Item'" [message]="'Are you sure you want to delete this item?'"
  [confirmText]="'Delete'" [cancelText]="'Cancel'">
</app-confirm-dialog>